import { useRouteError } from "react-router-dom";

const Error = () => {
	let error = useRouteError();

	console.log(error);

	return (
		<div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-2 tw-text-2xl tw-font-semibold tw-min-h-dvh">
			<p className="tw-text-base tw-text-slate-500">An unexpected error just occurred</p>
			<p>{error.message}</p>
		</div>
	);
};

export default Error;
